import React from "react";
import Header from "./Header";
import Movies from "./Movies";

export default function App() {
  return (
    <>
      <Header />
      <Movies />
    </>
  );
}
